// HomeHero.jsx
import React from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import videoSmMd from '../assets/pick/1103(1).mp4';
import videoLg from '../assets/pick/1103.mp4';

const HomeHero = () => {
    const { t } = useTranslation(); // Initialize translation

    return (
        <section className="relative min-h-screen w-full overflow-hidden">
            {/* Video for Mobile & Tablet (sm and md) */}
            <video
                className="absolute inset-0 w-full h-full object-cover lg:hidden"
                autoPlay
                loop
                muted
                playsInline
            >
                <source src={videoSmMd} type="video/mp4" />
                {t('hero.videoFallback')} {/* Translated fallback */}
            </video>

            {/* Video for Desktop (lg and up) */}
            <video
                className="absolute inset-0 w-full h-full object-cover hidden lg:block"
                autoPlay
                loop
                muted
                playsInline
            >
                <source src={videoLg} type="video/mp4" />
                {t('hero.videoFallback')}
            </video>

            {/* Dark Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/40"></div>

            {/* Hero Text & CTA */}
            <div className="relative z-10 flex flex-col items-center justify-center min-h-screen text-center px-4 sm:px-6 md:px-8">
                {/* Main Title */}
                <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold font-konkhmer text-white mb-4 sm:mb-6 bg-gradient-to-r from-[#009CE6] to-[#96BA33] bg-clip-text text-transparent animate-gradient-text">
                    {t('hero.title')}
                </h1>

                {/* Subtitle */}
                <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-redHatDisplay text-gray-100 max-w-3xl mx-auto leading-relaxed">
                    {t('hero.subtitle')}
                </p>

                {/* CTA Button */}
                <a
                    href="/tour"
                    className="mt-6 sm:mt-8 px-8 py-4 bg-gradient-to-r from-[#009CE6] to-[#96BA33] text-white font-semibold font-redHatDisplay rounded-full shadow-lg hover:from-[#007bb5] hover:to-[#7a9a2a] transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-[#009CE6]/50 text-base sm:text-lg"
                >
                    {t('hero.cta')}
                </a>
            </div>
        </section>
    );
};

export default HomeHero;